import {Button, Card, DatePicker, Form, Icon, Input, Radio, Select, Spin} from 'antd';
import React from "react";
import {getFormFieldByType, isArray, sanitizeFieldName} from "../../util/methods";
import SubList from "../../components/SubList";
import MasterModal from "../../components/MasterModal";
import * as moment from "moment";

class Create extends React.Component {
  constructor() {
    super();
    this.addAsset = this.addAsset.bind(this);
    this.id = 0;
    this.state = {
      keys: [],
      radioButtonValue: 'name'
    };
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    const {data: {assets = [{}]}} = this.props;
    this.setState({
      keys: assets,
    });
  }

  componentWillUnmount() {
    this.props.clearData();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.data && nextProps.data.assets && JSON.stringify(nextProps.data.assets) !== JSON.stringify(this.props.data.assets)) {
      this.setState({
        keys: nextProps.data.assets,
      });
    }
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  removeAsset = (index, boxIndex) => {
    const {keys} = this.state;
    const { form, filters } = this.props;
    const item = filters['assets'];
    if (keys.length === 1) {
      return;
    }
    const val = form.getFieldValue('assets');
    val.splice(boxIndex, 1);
    keys.splice(boxIndex, 1);
    for (let i = 0; i< val.length; i++) {
      Object.keys(item.schema).map((itm) => {
        form.setFieldsValue({
          [`assets[${i}]['${itm}']`]: val[i][itm],
        });
      });
    }
    this.setState({
      keys: keys,
    });
  };

  addAsset = () => {
    const {keys} = this.state;
    keys.push(`${'assets'}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  assetFormItems() {
    const {data, form, filters, assetsList, resource, title} = this.props;
    const {getFieldDecorator} = form;
    const {keys, assetsPresent} = this.state;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };
    return keys && isArray(keys) && keys.map((k, index) => {
      return <div key={index} style={style}>


        <Form.Item key={`${index}0`} label={'Select Asset'}>
          {getFieldDecorator(`assets[${index}]['asset']`, {
            rules: [{required: true, message: `Asset is required!`}],
            initialValue: data && data.assets && data.assets[index] && data.assets[index].asset && data.assets[index].asset._id || '',
          })(<Select
            showSearch
            mode="single"
            disabled={title === 'EDIT' || false}
            style={{width: '100%'}}
            placeholder="Please select asset"
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {title === 'CREATE' ? assetsList.map(item => {
              return <Select.Option key={item._id} value={item._id}>{item.assetCode}</Select.Option>
            }) : data && data.assets && data.assets[index] ? <Select.Option
              value={data && data.assets[index] && data.assets[index].asset && data.assets[index].asset._id}>{data.assets && data.assets[index].asset && data.assets[index].asset.assetCode}</Select.Option> : ''}

          </Select>)}
        </Form.Item>

        <Form.Item key={`${index}4`}
                   label={'Issued Upto'}>
          {getFieldDecorator(`assets[${index}]['issuedUpto']`, {
            rules: [{
              required: false,
              message: `Issued Upto is required!`
            }],
            initialValue: data && data.assets && data.assets[index] &&  data.assets[index]['issuedUpto'] && moment(data.assets[index]['issuedUpto']),
          })(<DatePicker disabled={ title === 'EDIT' || false} />)
          }
        </Form.Item>

        {index > 0 ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.removeAsset(`${k}`, index)}
          />
        ) : null}
      </div>
    });
  }

  getAssetsByLocation = (e) => {
    this.props.fetchAssetsByLocation(e);
  };

  onSearchBoxChange = (e) => {
    this.setState({
      radioButtonValue: e.target.value
    })
  }

  changeLocation = (e) => {
    const {form} = this.props;
    form.setFieldsValue({
      [`assets[0]['asset']`]: '',
    });
    this.setState({keys: [{}]});
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form} = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if (filters[item].type === 'Array' && filters[item].schema) {
                if (filters[item].field === 'assets') {
                  return <React.Fragment key={item}>
                    <div>Assets</div>
                    {this.assetFormItems()}
                    <Button type="dashed" onClick={this.addAsset} style={{width: '60%', marginTop: '15px'}}>
                      <Icon type="plus"/> Add Assets
                    </Button>
                  </React.Fragment>
                } else {
                  return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource}/>
                }
              } else {
                if(filters[item].field === 'location') {
                  return <Form.Item key={'location'} label={'Location'}>
                    {getFieldDecorator('location', {
                      rules: [{required: true, message: `Location is required!`}],
                      initialValue: data && data.location && data.location._id,
                    })(<Select
                      showSearch
                      style={{width: '80%'}}
                      onSelect={this.getAssetsByLocation}
                      onChange={this.changeLocation}
                      placeholder="Select Location"
                      disabled={title === 'EDIT' || false }
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {filters['location'] && filters['location']['data'] && filters['location']['data']['data'].map(item => !item.isSystemGenerated &&
                        <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                    </Select>)}
                    {
                      filters['location'] && filters['location'].options && filters['location'].options.master ?
                        <MasterModal resource={resource} item={filters['location'].options.ref} title={'CREATE'}/> : ''
                    }
                  </Form.Item>
                } else if (filters[item].field === 'employee') {
                  return <React.Fragment key={'employeebox'}>
                    <Form.Item key={'checkbox'}>
                      <label style={{marginRight: '10px'}}>Search By: </label>
                      <Radio.Group key={'radiobox'} onChange={this.onSearchBoxChange} value={this.state.radioButtonValue}>
                        <Radio value={'name'}>Employee Name</Radio>
                        <Radio value={'id'}>Employee Id</Radio>
                      </Radio.Group>
                    </Form.Item>
                    <Form.Item key={'employee'} label={'Employee'}>
                      {getFieldDecorator('employee', {
                        rules: [{required: true, message: `Employee is required!`}],
                        initialValue: data && data.employee && data.employee._id,
                      })(<Select
                        showSearch
                        style={{width: '80%'}}
                        placeholder="Select Employee"
                        disabled={title === 'EDIT' || false}
                        filterOption={(input, option) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {filters['employee'] && filters['employee']['data'] && filters['employee']['data']['data'].map(item =>
                          <Select.Option key={item._id} value={item._id}>{this.state.radioButtonValue === 'name' ? item.name : item.employeeCode}</Select.Option>)}
                      </Select>)}
                      {
                        filters['employee'] && filters['employee'].options && filters['employee'].options.master ?
                          <MasterModal resource={resource} item={filters['employee'].options.ref} title={'CREATE'}/> : ''
                      }
                    </Form.Item>
                  </React.Fragment>
                } else if (filters[item].field === 'issueNumber') {
                  return (title === 'EDIT') && <Form.Item key={'eaiNo'} label={'Issue Number'}>
                    {getFieldDecorator('issueNumber', {
                      rules: [{ required: false, message: `Issue Number is required!` }],
                      initialValue: ((data && data.issueNumber) || ''),
                    })(<Input disabled/>)
                    }
                  </Form.Item>
                } else {
                  return getFormFieldByType(filters, item, getFieldDecorator, data, { title: title, resource })
                }
              }
            })}

            <Form.Item>
              {
                title === 'CREATE' ? <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                  {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                </Button> : ''
              }
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
